export default __webpack_public_path__ + "static/media/SFProText-Regular-1.90da7ab1.ttf";